var _path, _path2, _path3, _path4, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgTetris = function SvgTetris(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    fill: "none",
    viewBox: "0 0 40 40"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#tetris_svg__a)",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: "M35.334 36.667c.467 0 .7 0 .878-.091a.833.833 0 0 0 .364-.364c.091-.178.091-.412.091-.879V18c0-.466 0-.7-.09-.878a.833.833 0 0 0-.365-.364c-.178-.091-.411-.091-.878-.091h-4c-.467 0-.7 0-.878.09a.833.833 0 0 0-.364.365C30 17.3 30 17.534 30 18v4c0 .467 0 .7-.091.878a.833.833 0 0 1-.364.365c-.179.09-.412.09-.879.09h-4c-.466 0-.7 0-.878.091a.833.833 0 0 0-.364.364c-.091.179-.091.412-.091.879v4c0 .466 0 .7-.09.878a.833.833 0 0 1-.365.364c-.178.091-.412.091-.878.091h-4c-.467 0-.7 0-.879.091a.833.833 0 0 0-.364.364c-.09.178-.09.412-.09.879v4c0 .466 0 .7.09.878.08.157.207.284.364.364.179.09.412.09.879.09h17.333Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#tetris_svg__b)",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: "M16.667 11.334c0-.467 0-.7.091-.879a.833.833 0 0 1 .364-.364c.179-.09.412-.09.879-.09h4c.466 0 .7 0 .878.09.157.08.284.207.364.364.091.178.091.412.091.879v4c0 .466 0 .7-.09.878a.833.833 0 0 1-.365.364c-.178.09-.412.09-.878.09h-4c-.467 0-.7 0-.879-.09a.833.833 0 0 1-.364-.364c-.09-.178-.09-.412-.09-.878v-4Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#tetris_svg__c)",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: "M5 21.334c0-.467 0-.7.091-.879a.833.833 0 0 1 .365-.364c.178-.09.411-.09.878-.09h4c.467 0 .7 0 .878.09.157.08.285.207.364.364.091.178.091.412.091.879v4c0 .466 0 .7-.09.878a.833.833 0 0 1-.365.364c-.178.09-.411.09-.878.09h-4c-.467 0-.7 0-.878-.09a.833.833 0 0 1-.365-.364c-.09-.178-.09-.412-.09-.878v-4Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#tetris_svg__d)",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: "M3.334 4.667c0-.467 0-.7.09-.878a.833.833 0 0 1 .365-.365c.178-.09.412-.09.878-.09h4c.467 0 .7 0 .879.09.156.08.284.208.364.365.09.178.09.411.09.878v4c0 .467 0 .7-.09.878a.833.833 0 0 1-.364.364C9.367 10 9.134 10 8.667 10h-4c-.466 0-.7 0-.878-.09a.833.833 0 0 1-.364-.365c-.091-.178-.091-.411-.091-.878v-4Z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "tetris_svg__a",
    x1: 33.71,
    x2: -32.907,
    y1: 4.254,
    y2: 29.759,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8B61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D92E7F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "tetris_svg__b",
    x1: 33.71,
    x2: -32.907,
    y1: 4.254,
    y2: 29.759,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8B61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D92E7F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "tetris_svg__c",
    x1: 33.71,
    x2: -32.907,
    y1: 4.254,
    y2: 29.759,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8B61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D92E7F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "tetris_svg__d",
    x1: 33.71,
    x2: -32.907,
    y1: 4.254,
    y2: 29.759,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8B61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D92E7F"
  })))));
};
export default SvgTetris;